import { HttpError } from '../../business/httpError';
import { AxiosError } from 'axios';
import { portal } from '../../../shared/assets/plugins/axios/axios';
import { groupMembershipActions } from '../../../shared/enums/groupMembershipActions';

class GroupService {
  public joinOrLeaveGroup = async (payload: {
    groupId: number;
    institutionProfileIds: number[];
    groupAccessType: groupMembershipActions;
  }) => {
    try {
      const { data } = await portal.post('?method=groups.joinOrLeaveGroup', payload);
      return data.data;
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };
}

export const groupService = new GroupService();
